export default {
  title: 'Ostatnie 4 tygodnie',
  item_interval: '(1)[1 wizyta];(2)[2 wizyty];(3-5)[3–5 wizyt];(6-inf)[6+ wizyt];',
  total: 'Łączna liczba odwiedzających',
};
